export default __webpack_public_path__ + "static/louise-jones-22916fc58db13d1c984fc05af248113e.png";